import { Context } from '@nuxt/types'
import createPersistedState from 'vuex-persistedstate'
import { authCookieName } from '@/utils/auth'

export default ({ store, isDev, $cookies, $axios }: Context) => {
  // persist auth state as cookie
  createPersistedState<{ auth: { token?: string; refreshToken?: string } }>({
    key: authCookieName,
    paths: ['auth.token', 'auth.refreshToken'],
    filter(mutation) {
      return ['auth/setAccessTokens', 'auth/reset'].includes(mutation.type)
    },
    storage: {
      getItem: (key) => {
        const value = $cookies.get(key)
        return value
      },
      setItem: (key, value) => {
        const parsedValue = JSON.parse(value)
        const { token, refreshToken } = parsedValue.auth
        if (token === null && refreshToken === null) {
          $cookies.remove(key, { path: '/' })
          return
        }

        const expires = new Date()
        expires.setFullYear(expires.getFullYear() + 1)
        $cookies.set(key, parsedValue, { expires, secure: !isDev, path: '/' })
      },
      removeItem: (key) => {
        $cookies.remove(key, { path: '/' })
      },
    },
    assertStorage: () => {},
    rehydrated(store) {
      const token = store.state.auth.token
      if (token) {
        $axios.setToken(token, 'Bearer')
      }
    },
  })(store)
}
